module.exports = __webpack_public_path__ + "img/other.97d9f371.png";